import React from 'react';
import { Box, Card, CardContent, CardHeader, Divider, Grid, Typography } from '@mui/material';
import { TitleEntity, VersionGroupedByParent } from '@/redux/slices/slice_types';
import { TitleEntityV2 } from '@/redux/slices/titleV2Slice.types';
import TitleTypeLabel from '@/components/_common/TitleTypeLabel';
import TitleVersionChip from '@/components/_common/TitleVersionChip';

interface Props {
  feature: TitleEntity | TitleEntityV2;
  featureChildren: VersionGroupedByParent;
  parentYear: number;
}

const Feature: React.FC<Props> = ({ feature, featureChildren, parentYear }) => {
  return (
    <Card sx={{ mb: 2 }} elevation={0}>
      <CardHeader
        title={
          <Grid container alignItems="center">
            <Grid item sx={{ display: 'flex', alignItems: 'center', maxWidth: '70%' }}>
              <Typography variant="body2" sx={{ fontSize: '1.1rem' }}>
                {feature.name}
                {!!parentYear && (
                  <Typography variant="caption" sx={{ ml: 0.5 }}>
                    ({parentYear})
                  </Typography>
                )}
              </Typography>
            </Grid>
            <Grid item sx={{ ml: 1.5 }}>
              <TitleTypeLabel type={feature.entity_type} />
            </Grid>
          </Grid>
        }
      />
      <CardContent sx={{ pb: 0, pt: 1 }}>
        <Box>
          {Object.keys(featureChildren).map((fcId) => {
            const fc = featureChildren[fcId];
            return (
              <Grid key={fcId} container alignItems="center" sx={{ py: 0.5 }}>
                <Grid item flex="auto">
                  <Divider sx={{ borderColor: 'action.selected', borderStyle: 'dashed', mr: 2 }} />
                </Grid>
                <Grid item>
                  <TitleVersionChip version={fc} withTooltip />
                </Grid>
              </Grid>
            );
          })}
        </Box>
      </CardContent>
    </Card>
  );
};

export default Feature;
